import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/notification_records',
  component: Management,
  redirect: '/notification_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/notification_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listNotificationRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/notification_records/ListTable'),
          meta: {
            auth: Auth.listNotificationRecords,
            tabName: 'all'
          }
        },
        {
          path: 'alarm',
          component: () => import('@/views/notification_records/ListTable'),
          meta: {
            auth: Auth.listNotificationRecords,
            tabName: 'alarm'
          }
        },
        {
          path: 'work_order',
          component: () => import('@/views/notification_records/ListTable'),
          meta: {
            auth: Auth.listNotificationRecords,
            tabName: 'work_order'
          }
        },
        {
          path: 'product',
          component: () => import('@/views/notification_records/ListTable'),
          meta: {
            auth: Auth.listNotificationRecords,
            tabName: 'product'
          }
        }
      ]
    }
  ]
}
